// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1062": "da66651d05ee","2530": "e96a97f91d26","3573": "ffd50735d5c1","461": "e559ad530676","5954": "e0dad2cb3e9d","6863": "454c9f289029","8248": "70829c6fcf43","8335": "e195c41c065e","8357": "dd422574e14d","9552": "b282c5b10959",}[chunkId] + ".css"
}